import { InterfaceTab, IRCMessageType, tabType } from "#/types/types";

export default class CommandHandler {
    private ircClient: any;

    constructor(ircClient: any) {
        this.ircClient = ircClient;
    }

    handleCommand(tab: InterfaceTab, command: string): void {

        const parts = command.slice(1).split(' ');
        const cmd = parts[0].toLowerCase();
        const tM = this.ircClient.tabManager;
        const activeTab = tM.getActiveTab();
        const mH = this.ircClient.messageHandler;
        const cH = this.ircClient.connectionHandler;

        switch (cmd) {
            case 'nick':
                if (parts[1]) {
                    cH.sendIRCCommand('NICK', parts[1]);
                } else {
                    mH.addMessage(activeTab, 'Usage: /nick <new_nickname>', IRCMessageType.ERROR);
                }
                break;
            case 'query':
            case 'q':
            case 'msg':
                if (parts[1]) {
                    const target = parts[1];
                    let targetTab: InterfaceTab | null;
                    if (target.startsWith('#')) {
                        targetTab = tM.getTab(tabType.CHANNEL, target);
                    } else {
                        targetTab = tM.getTab(tabType.QUERY, target);
                        if (!targetTab) {
                            this.openQueryWindow(target);
                            targetTab = tM.getTab(tabType.QUERY, target);
                        }
                    }
                    if (parts[2] && targetTab) {
                        const message = parts.slice(2).join(' ');
                        cH.sendMessage(target, message);
                        const nicknameInput = document.getElementById('irc-nickname') as HTMLInputElement;
                        const nickname = nicknameInput?.value || 'Unknown';
                        mH.addMessage(targetTab, message, IRCMessageType.DEFAULT, nickname);
                    }
                } else {
                    mH.addMessage(activeTab, 'Usage: /msg <nick> [message]', IRCMessageType.ERROR);
                }
                break;
            case 'notice':
                if (parts[1] && parts[2]) {
                    const target = parts[1];
                    const message = parts.slice(2).join(' ');
                    cH.sendRaw(command.slice(1));
                    mH.addMessage(activeTab, `-${target}- ${message}`, IRCMessageType.NOTICE);
                } else {
                    mH.addMessage(activeTab, 'Usage: /notice <nick> [message]', IRCMessageType.ERROR);
                }
                break;
            case 'quit':
            case 'disconnect':
                const quitMessage = parts.slice(1).join(' ') || 'LostHQ IRC Client';
                cH.sendIRCCommand('QUIT', quitMessage);
                cH.disconnect();
                tM.closeAllTabs();
                break;
            case 'me':
                if (parts[1]) {
                    const action = parts.slice(1).join(' ');
                    const actionMessage = `\x01ACTION ${action}\x01`;
                    cH.sendMessage(activeTab, actionMessage);
                    const nicknameInput = document.getElementById('irc-nickname') as HTMLInputElement;
                    const nickname = nicknameInput?.value || 'Unknown';
                    mH.addMessage(activeTab, `* ${nickname} ${action}`, IRCMessageType.ACTION, nickname);
                } else {
                    mH.addMessage(activeTab, 'Usage: /me <action>', IRCMessageType.ERROR);
                }
                break;
            default:
                cH.sendRaw(command.slice(1));
        }
    }

    openQueryWindow(target: string): void {
        const existingTab = this.ircClient.tabManager.getTab(tabType.QUERY, target);

        if (!existingTab) {
            this.ircClient.tabManager.addTab(tabType.QUERY, target);
        } else {
            if (existingTab.name !== target) {
                this.ircClient.tabManager.updateTabName(existingTab.name, target);
            }
        }

        const targetTab = this.ircClient.tabManager.getTab(tabType.QUERY, target);
        if (targetTab) {
            this.ircClient.tabManager.setActiveTab(targetTab);
        }
    }

    joinChannel(channel: string): void {
        if (!channel.startsWith('#')) {
            channel = '#' + channel;
        }
        this.ircClient.connectionHandler.joinChannel(channel);
    }

    partChannel(channel: string, reason: string = ''): void {
        if (!channel.startsWith('#')) {
            channel = '#' + channel;
        }
        this.ircClient.connectionHandler.partChannel(channel, reason);
    }

}